export const ROLES = [
  { value: "director", label: "Director", short: "DIR" },
  { value: "admin", label: "Tech Admin", short: "TADM" },
  { value: "admin_manager", label: "Admin Manager", short: "AM" },
  { value: "assistant_manager", label: "Sales Manager", short: "SM" },
  { value: "sales_officer", label: "Sales Officer", short: "SO" },
];

export const ROLE_LABEL = {
  director: "Director",
  admin: "Tech Admin",
  admin_manager: "Admin Manager",
  assistant_manager: "Sales Manager",
  sales_officer: "Sales Officer",
};

// Mirrors backend/team_scope.py SELF_SERVICE_ROLES. Everyone in this list files
// their own leaves and expenses, so every "file a claim" form must admit them —
// guarding those forms on `sales_officer` alone silently bounces both manager
// tiers back to the list view.
export const SELF_SERVICE_ROLES = ["sales_officer", "assistant_manager", "admin_manager"];

// The subset that ALSO oversees others, and therefore needs a My/Team switch.
export const SELF_SERVICE_MANAGERS = ["assistant_manager", "admin_manager"];

export const ROLE_BADGE_CLS = {
  director: "bg-callisto-navy text-callisto-gold",
  admin: "bg-callisto-gold/10 text-callisto-gold",
  admin_manager: "bg-violet-50 text-violet-700",
  assistant_manager: "bg-emerald-50 text-emerald-700",
  sales_officer: "bg-sky-50 text-sky-700",
};

export function userInitials(fullName) {
  if (!fullName) return "?";
  return fullName
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}
